var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkeletonUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9785",
    "data-name": "Rectangle 9785",
    width: 27,
    height: 23.424,
    fill: "#ababab"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33625",
    "data-name": "Group 33625",
    transform: "translate(22396 19077)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1106",
    "data-name": "Ellipse 1106",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(-22396 -19077)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33614",
    "data-name": "Group 33614",
    transform: "translate(-22385.5 -19064.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33613",
    "data-name": "Group 33613",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70486",
    "data-name": "Path 70486",
    d: "M13.5,23.422H0a5.287,5.287,0,0,1,.834-1.889A4.2,4.2,0,0,1,2.152,20.4C3.7,19.519,7.8,19.247,9.328,18.007a17.342,17.342,0,0,0,.614-1.693c.008-.024-.012.039.063-.189a1,1,0,0,0-.2-.735c-.284-.474-.762-1.007-.975-1.349L7.571,12.008a3.746,3.746,0,0,1-.711-1.857,1.471,1.471,0,0,1,.125-.662,1.229,1.229,0,0,1,.431-.511,1.472,1.472,0,0,1,.3-.159,33.118,33.118,0,0,1-.059-3.654,5.065,5.065,0,0,1,.155-.829A5.313,5.313,0,0,1,11.3.89c.783-.275.481-.932,1.271-.889A6.65,6.65,0,0,1,13.5.125c1.764.614,1.152.394,2.2.763a5.31,5.31,0,0,1,3.484,3.446,5.065,5.065,0,0,1,.155.829,33.118,33.118,0,0,1-.059,3.654,1.515,1.515,0,0,1,.306.159,1.235,1.235,0,0,1,.43.511,1.488,1.488,0,0,1,.124.664,3.779,3.779,0,0,1-.711,1.857l-1.256,2.032c-.212.344-.691.876-.975,1.349a.99.99,0,0,0-.2.735,1.176,1.176,0,0,1,.059.189c.149.458.384,1.185.614,1.693,1.534,1.239,5.629,1.512,7.176,2.391a4.185,4.185,0,0,1,1.319,1.136A5.237,5.237,0,0,1,27,23.424Z",
    transform: "translate(0 0)",
    fill: "#ababab",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeletonUser);
export default __webpack_public_path__ + "static/media/skeleton-user.3c857a04680142c11f006ae817704d6c.svg";
export { ForwardRef as ReactComponent };